"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alpignano": {
    "9c3e14fb": [{
      "hkey": "961fdefb",
      "slug": "alpignano",
      "name": "Alpignano",
      "primary": true,
      "skipSearch": false
    }],
    "campagnola": [{
      "hkey": "961fdefb",
      "slug": "alpignano",
      "name": "Alpignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "565c46fd": [{
      "hkey": "961fdefb",
      "slug": "alpignano",
      "name": "Alpignano",
      "primary": true,
      "skipSearch": false
    }],
    "ferna": [{
      "hkey": "961fdefb",
      "slug": "alpignano",
      "name": "Alpignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "213bb6af": [{
      "hkey": "961fdefb",
      "slug": "alpignano",
      "name": "Alpignano",
      "primary": true,
      "skipSearch": false
    }],
    "grange-palmero": [{
      "hkey": "961fdefb",
      "slug": "alpignano",
      "name": "Alpignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7889bb7a": [{
      "hkey": "961fdefb",
      "slug": "alpignano",
      "name": "Alpignano",
      "primary": true,
      "skipSearch": false
    }],
    "maggiore": [{
      "hkey": "961fdefb",
      "slug": "alpignano",
      "name": "Alpignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb530b2d": [{
      "hkey": "961fdefb",
      "slug": "alpignano",
      "name": "Alpignano",
      "primary": true,
      "skipSearch": false
    }],
    "san-giacomo": [{
      "hkey": "961fdefb",
      "slug": "alpignano",
      "name": "Alpignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e80ac8cd": [{
      "hkey": "961fdefb",
      "slug": "alpignano",
      "name": "Alpignano",
      "primary": true,
      "skipSearch": false
    }],
    "sassetto": [{
      "hkey": "961fdefb",
      "slug": "alpignano",
      "name": "Alpignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;